module.exports = __webpack_public_path__ + "img/form-logo.b7f31245.png";